var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"materialbutton cursor-pointer whitespace-pre rounded font-display text-sm px-6 py-2 border border-gray-200 transition-colors",class:_vm.type},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }